// TODO: It's likely that we may want parts of this to be
// in a provider + context, instead of a zustand store.

import _ from 'lodash';
import { create } from 'zustand';

export type ChatPinStore = {
  isPinnable: (responseIndex?: number) => boolean;

  // Entry is multiChatIndex:responseIndex
  pinnedIndexes: string[];
  isPinnedIndex: (responseIndex: number, multiChatIndex?: number) => boolean;
  addPinnedIndex: (responseIndex: number, multiChatIndex?: number) => void;
  removePinnedIndex: (responseIndex: number, multiChatIndex?: number) => void;

  // key is multiChatIndex:responseIndex:prompt
  pinnedMessages: { [key: string]: any };
  isPinnedMessage: (responseIndex: number, multiChatIndex?: number) => boolean;
  addPinnedMessage: (responseIndex: number, message: any, multiChatIndex?: number) => void;
  removePinnedMessage: (responseIndex: number, multiChatIndex?: number) => void;
  getPinnedMessage: (responseIndex: number, multiChatIndex?: number) => any;

  reset: () => void;
};

export const usePinStore = create<ChatPinStore>((set, get) => ({
  isPinnable: (responseIndex?: number) => {
    if (responseIndex !== undefined) {
      return true;
    }
    return false;
  },

  pinnedIndexes: [],
  isPinnedIndex: (responseIndex: number, multiChatIndex?: number) => {
    const entry = getPinnedIndexEntry(responseIndex, multiChatIndex);
    return get().pinnedIndexes.includes(entry);
  },
  addPinnedIndex: (responseIndex: number, multiChatIndex?: number) => {
    const entry = getPinnedIndexEntry(responseIndex, multiChatIndex);
    if (get().pinnedIndexes.includes(entry)) {
      return;
    }
    set(state => ({
      pinnedIndexes: [...state.pinnedIndexes, entry],
    }));
  },
  removePinnedIndex: (responseIndex: number, multiChatIndex?: number) => {
    const entry = getPinnedIndexEntry(responseIndex, multiChatIndex);
    set(state => ({
      pinnedIndexes: state.pinnedIndexes.filter(i => i !== entry),
    }));
  },

  pinnedMessages: {},
  isPinnedMessage: (responseIndex: number, multiChatIndex?: number) => {
    const key = getPinnedMessageKey(responseIndex, multiChatIndex);
    return get().pinnedMessages[key];
  },
  addPinnedMessage: (responseIndex: number, message: any, multiChatIndex?: number) => {
    const key = getPinnedMessageKey(responseIndex, multiChatIndex);
    set(state => ({
      pinnedMessages: { ...state.pinnedMessages, [key]: message },
    }));
  },
  removePinnedMessage: (responseIndex: number, multiChatIndex?: number) => {
    const key = getPinnedMessageKey(responseIndex, multiChatIndex);
    set(state => ({
      pinnedMessages: _.omit(state.pinnedMessages, key),
    }));
  },
  getPinnedMessage: (responseIndex: number, multiChatIndex?: number) => {
    const key = getPinnedMessageKey(responseIndex, multiChatIndex);
    return get().pinnedMessages[key];
  },

  reset: () => {
    set({ pinnedIndexes: [], pinnedMessages: {} });
  },
}));

function getPinnedIndexEntry(responseIndex: number, multiChatIndex?: number) {
  if (multiChatIndex !== undefined) {
    return `${multiChatIndex}:${responseIndex}`;
  }
  return `${responseIndex}`;
}

function getPinnedMessageKey(responseIndex: number, multiChatIndex?: number) {
  if (multiChatIndex !== undefined) {
    return `${multiChatIndex}:${responseIndex}:prompt`;
  }
  return `${responseIndex}:prompt`;
}
